const initGDPRAppRules = () => {
  
    window.addEventListener('PandectesEvent_OnConsent',(e)=>{
      console.log(e.detail.preferences)
      if (e.detail.preferences === 0) {
        // console.log('tracking accepted, enabling legal consent in Kameleoon...');
        console.log("true");
        window.kameleoonQueue = window.kameleoonQueue || [];
        Kameleoon.API.Core.enableLegalConsent()
        window.kameleoonQueue.push(["Kameleoon.API.Core.enableLegalConsent"]);
      }else {
        console.log("false");
        window.kameleoonQueue = window.kameleoonQueue || [];
        Kameleoon.API.Core.disableLegalConsent()
        window.kameleoonQueue.push(["Kameleoon.API.Core.disableLegalConsent"]);
      }
    })
  };
  
  initGDPRAppRules()